import React from "react";
import { get } from "lodash";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import queryString from "query-string";
import { createFetch } from "../../utils";
import { bindActionCreators } from "redux";
import { registerLoginInfo } from "./actions";
import {
  Grid,
  Typography,
  Input,
  InputLabel,
  FormControl,
  Box,
} from "@mui/material";
import LoginBackground from "../../static/img/login-background.png";
import "./styles.scss";
import WakatobiLogo from "../../static/img/wakatobi-logo-1.svg";
import VektorImage1 from "../../static/img/background/login-vector-botLeft.svg";
const { URL_PREFIX } = window;

class VF1Login extends React.Component {
  constructor() {
    super();
    const url = new URL(window.location.href);
    const soNum = url.searchParams.get("soNum") || "";
    const soEmail = url.searchParams.get("soEmail") || "";
    const passCode = url.searchParams.get("soPassCode") || "";
    this.state = {
      errorMessage: null,
      form: {
        soNum,
        soEmail,
        passCode,
      },
      loading: false,
    };
    this.login = this.login.bind(this);
    document.title = "Wakatobi - Visit Form 1";
  }

  changeForm(key, value) {
    const { form } = this.state;
    form[key] = value;
    this.setState({ form });
  }

  componentWillMount() {
    let params = queryString.parse(this.props.location.search);
    this.setState({
      form: {
        soNum: get(params, "sonum", ""),
        soEmail: get(params, "soemail", ""),
        passCode: get(params, "sopasscode", ""),
      },
    });
  }

  async login(e) {
    e.preventDefault();
    try {
      const { soNum, soEmail, passCode } = this.state.form;
      const result = await createFetch({
        path: "vf1/login",
        method: "POST",
        accessToken: null,
        body: {
          so_num: soNum,
          so_email: soEmail,
          so_passcode: passCode,
        },
      });

      if (result.status === 200) {
        this.props.registerLoginInfo({
          token: result.token.token,
          expired: result.token.expired,
          soId: result.soId,
        });
        this.props.history.push(`${URL_PREFIX}/vf1/wizard`);
      }
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    const { errorMessage, form, loading } = this.state;
    return (
      <div className="wrapper with-background">
        <Grid container rowSpacing={1}>
          <Grid item md={6} sm={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                height: 60,
                marginTop: "67px",
              }}
            >
              <img src={WakatobiLogo} alt="Logo Dreams" />
            </Box>
            <div
              className="login-box"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <p className="text-center">
                {loading ? (
                  <i className="fa fa-circle-notch fa-spin fa-2x loading" />
                ) : null}
              </p>

              <div className="account-wall">
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    sx={{
                      color: "#101828",
                      fontWeight: 600,
                      marginBottom: "20px",
                    }}
                  >
                    Login to your sales order
                  </Typography>
                  <Typography variant="text-large" sx={{ color: "#667085" }}>
                    Please enter your details according to the email <br />
                    have received
                  </Typography>
                </div>
                {errorMessage ? (
                  <div
                    className="alert alert-warning alert-dismissible"
                    role="alert"
                    id="login_alert"
                  >
                    <span>{errorMessage}</span>
                  </div>
                ) : null}
                <div style={{ marginTop: "20px" }}>
                  <form className="form-signin">
                    <input type="hidden" name="_token" value="" />
                    <FormControl>
                      <InputLabel>Sales Order No.</InputLabel>
                      <Input
                        type="text"
                        placeholder="SO-XXXXXX"
                        name="so_num"
                        value={form.soNum}
                        required
                        onChange={(e) =>
                          this.changeForm("soNum", e.target.value)
                        }
                      />
                    </FormControl>
                    <FormControl>
                      <InputLabel>Email</InputLabel>
                      <Input
                        type="text"
                        placeholder="example@mail.com"
                        name="so_email"
                        value={form.soEmail}
                        required
                        onChange={(e) =>
                          this.changeForm("soEmail", e.target.value)
                        }
                      />
                    </FormControl>
                    <FormControl>
                      <InputLabel>Passkey</InputLabel>
                      <Input
                        type="password"
                        placeholder="Passcode"
                        name="so_passcode"
                        value={form.passCode}
                        required
                        onChange={(e) =>
                          this.changeForm("passCode", e.target.value)
                        }
                      />
                    </FormControl>
                    <button
                      disabled={loading}
                      className="btn btn-lg btn-primary btn-block"
                      style={{
                        width: "412px",
                        marginTop: "30px",
                        height: "auto",
                        background: "#66C7D1",
                        color: "black",
                        fontWeight: 600,
                        fontSize: "16px",
                        border: "1px solid #66C7D1",
                      }}
                      type="submit"
                      onClick={this.login}
                    >
                      <i className="fa fa-sign-in" /> Login
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </Grid>
          <Grid item md={6} sm={12}>
            <img
              src={LoginBackground}
              alt="login-background"
              style={{ width: "100%", height: "100vh" }}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

VF1Login.propTypes = {
  registerLoginInfo: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      registerLoginInfo,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  vf1: state.vf1,
});

export default connect(mapStateToProps, mapDispatchToProps)(VF1Login);
